/**
 * Validates one field for given object
 * @param fieldName
 * @param value
 * @param object
 * @returns {{}}
 */
export function validateObjectField(validationDefinitions, fieldName, value, object) {
    if (validationDefinitions.hasOwnProperty(fieldName)) {
        const errors = validationDefinitions[fieldName](value);
        const newObject = {...object};

        if (newObject[fieldName].errors !== null
            && newObject[fieldName].errors !== undefined) {
            newObject[fieldName].errors.length = 0;
        }

        if (errors !== null) {
            newObject[fieldName].errors = errors;
        }
        return newObject;
    } else {
        return object;
    }
}

/**
 * validate all fields for given objects
 * @param object
 */
export function validateObject(validationDefinitions, object) {
    let newObject = {...object};
    Object.keys(object).forEach(key => {
        newObject = Object.assign({}, newObject, validateObjectField(validationDefinitions, key, object[key].value, object))
    });
    return newObject;
}


/**
 * Find if object contains validation errors. Object representation of form input in this object is : fieldName : {value : realValueOnForm, errors : [array of errors for this field]}
 * @param object
 * @returns {boolean}
 */
export function objectContainsError(object) {
    let status = false
    Object.keys(object).forEach(key => {
        if (object[key].errors !== null && object[key].errors !== undefined && object[key].errors.length > 0) {
            status = true;
        }
    });
    return status;
}


// WEBPACK FOOTER //
// ./src/utils/ValidationUtils.js